import { Link } from "react-router-dom";
import { ArrowUpRight, AlertCircle, Lightbulb, TrendingUp } from "lucide-react";
import { CASE_STUDIES } from "../data/site";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import { CtaBlock } from "./About";

export default function CaseStudies() {
  return (
    <>
      <PageHero
        eyebrow="Case studies"
        title={<>Proven outcomes.<br/><span className="text-[var(--primary)]">Documented impact.</span></>}
        subtitle="Independent engineering, measurable results. Read the full story behind UMD's flagship deployments across Australia's most critical sectors."
        image="https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?auto=format&fit=crop&w=1920&q=80"
      />

      <section className="py-12 md:py-20">
        {CASE_STUDIES.map((cs, i) => (
          <Reveal key={cs.slug}>
            <div className={`py-16 md:py-24 ${i % 2 ? "bg-[#fafafa]" : "bg-white"}`}>
              <div className="container-wide grid md:grid-cols-12 gap-10 items-center">
                <div className={`md:col-span-6 ${i % 2 ? "md:order-2" : ""}`}>
                  <img src={cs.image} alt={cs.title} className="w-full aspect-[4/3] object-cover" />
                </div>
                <div className={`md:col-span-6 ${i % 2 ? "md:order-1 md:pr-12" : "md:pl-12"}`}>
                  <div className="eyebrow mb-5">{cs.client}</div>
                  <h2 className="font-display text-3xl md:text-5xl leading-[1] tracking-tight">{cs.title}</h2>
                  <div className="font-display text-2xl md:text-3xl text-[var(--primary)] mt-6 tracking-tight">{cs.metric}</div>

                  <div className="mt-10 space-y-6">
                    <Block icon={AlertCircle} label="Problem" text={cs.problem} />
                    <Block icon={Lightbulb} label="Solution" text={cs.solution} />
                    <Block icon={TrendingUp} label="Result" text={cs.result} />
                  </div>

                  <Link to="/contact" data-testid={`cs-cta-${cs.slug}`} className="btn-ghost mt-10">Discuss a similar program <ArrowUpRight size={14}/></Link>
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </section>

      <CtaBlock />
    </>
  );
}

const Block = ({ icon: Icon, label, text }) => (
  <div className="flex gap-5">
    <Icon size={22} className="text-[var(--primary)] mt-1 shrink-0" strokeWidth={1.6}/>
    <div>
      <div className="font-mono-tech text-[10px] tracking-[0.2em] uppercase text-[var(--muted-fg)]">{label}</div>
      <p className="mt-1 text-base leading-relaxed text-[#222]">{text}</p>
    </div>
  </div>
);
